export const FETCH_PRODUCTS_PENDING = 'home/FETCH_PRODUCTS_PENDING'
export const FETCH_PRODUCTS_SUCCESS = 'home/FETCH_PRODUCTS_SUCCESS'
export const FETCH_PRODUCTS_FAILED = 'home/FETCH_PRODUCTS_FAILED'
export const SET_CAROUSEL_PRODUCTS = 'home/SET_CAROUSEL_PRODUCTS'
export const FLIP_PRODUCT = 'home/FLIP_PRODUCT'
export const RESET = 'home/RESET'
export const OPEN_PRODUCT_MODAL = 'home/OPEN_PRODUCT_MODAL'
export const OPEN_PRODUCT_ALI_REF_MODAL = 'home/OPEN_PRODUCT_ALI_REF_MODAL'
export const OPEN_PRODUCT_OTHERS_MODAL = 'home/OPEN_PRODUCT_OTHERS_MODAL'
export const CLOSE_PRODUCT_MODAL = 'home/CLOSE_PRODUCT_MODAL'
export const CLOSE_PRODUCT_ALI_REF_MODAL = 'home/CLOSE_PRODUCT_ALI_REF_MODAL'
export const CLOSE_PRODUCT_OTHERS_MODAL = 'home/CLOSE_PRODUCT_OTHERS_MODAL'
export const OPEN_PAT_MODAL = 'home/OPEN_PAT_MODAL'
export const CLOSE_PAT_MODAL = 'home/CLOSE_PAT_MODAL'
